module.exports = __webpack_public_path__ + "4dc0c81c92f321d81a38a5a1a976c31e.cur";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/cur/circle-60.cur
// module id = 468
// module chunks = 0